import { render, staticRenderFns } from "./ModalApprovalDoa.vue?vue&type=template&id=517da6c3&scoped=true&"
import script from "./ModalApprovalDoa.vue?vue&type=script&lang=js&"
export * from "./ModalApprovalDoa.vue?vue&type=script&lang=js&"
import style0 from "./ModalApprovalDoa.vue?vue&type=style&index=0&id=517da6c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517da6c3",
  null
  
)

export default component.exports